import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: wrap;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.darkerblue};
`;

export const SubTitle = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.label};
  margin-left: 6px;
`;

export const InfoLine = styled.div`
  display: flex;
  gap: 14px;
  font-size: 11px;
  color: ${(props) => props.theme.colors.label};
  font-variant-numeric: tabular-nums;
`;

export const InfoItem = styled.span`
  strong {
    color: ${(props) => props.theme.colors.darkerblue};
    font-weight: 700;
    margin-left: 3px;
  }
`;

export const ChartWrapper = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  position: relative;
`;

export const EmptyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: ${(props) => props.theme.colors.label};
  font-size: 13px;
  font-style: italic;
  opacity: 0.7;
`;
